import { FormControl } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekFormControl = styled(FormControl)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.body1), { margin: `${theme.spacing(1)} 0` })));

export { PeekFormControl, PeekFormControl as default };
